import { useEffect } from "react"
import { useStore, useStoreActions } from "../../store"
import { useAuth } from "../../utility/useAuth"
import { StyledLogout } from "./Logout.styles"

export const Logout = () => {
    const auth = useAuth()
    const {
      user: { resetUser },
    } = useStoreActions((actions) => actions)
  
    const store = useStore()
    // const timedOut = new URLSearchParams(window.location.search).has('timeout')
  
    useEffect(() => {
      const flushState = async (): Promise<void> => {
        // Clear state before logout
        resetUser()
  
        // Flush the state store
        await store.persist.flush()
  
        // Logout
        auth.logout()
      }
  
      flushState()
    }, []) // eslint-disable-line
  
    return <StyledLogout />
  }